
import { motion } from 'framer-motion';

export default function PricingHero() {
  return (
    <section className="relative pt-32 pb-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0ff91022277618bb91f3185f2ecc57a7.jpg"
          alt="Service chauffeur privé premium dans les Alpes"
          title="Tarifs transfert privé Alpes"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center w-full"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: 'spring' }}
            className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-voyage-gold to-amber-500 rounded-full mb-6 shadow-2xl"
          >
            <i className="ri-price-tag-3-line text-4xl text-white"></i>
          </motion.div>

          <h1 className="font-playfair text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
            <strong>Tarifs &amp; Simulateur</strong>
          </h1>
          <p className="font-inter text-xl md:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed">
            Calculez instantanément le prix de votre <strong>transfert premium</strong> vers les Alpes. Prix fixes, transparents et tout compris.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mt-8">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/15 backdrop-blur-sm rounded-full text-white font-inter text-sm">
              <i className="ri-calculator-line text-voyage-gold"></i>
              Simulateur instantané
            </span>
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/15 backdrop-blur-sm rounded-full text-white font-inter text-sm">
              <i className="ri-shield-check-line text-voyage-gold"></i>
              Prix fixes tout compris
            </span>
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/15 backdrop-blur-sm rounded-full text-white font-inter text-sm">
              <i className="ri-eye-off-line text-voyage-gold"></i>
              Zéro frais cachés
            </span>
          </div>

          <motion.a
            href="#simulateur"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="inline-flex items-center gap-2 mt-10 px-8 py-4 bg-gradient-to-r from-voyage-gold to-amber-500 text-night-blue rounded-full font-inter font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calculator-line text-xl"></i>
            Simuler mon prix
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}
